import { Block } from 'webiq.boilerplate'

export default class LpHeroBanner extends Block {
	static title = 'lp-hero-banner'

	init() {
		this.explore = this.getElement('explore')
        this.firstSection = document.querySelector('.lp-section--news')

        this.explore.addEventListener('click', () => {
            this.firstSection.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
        })
	}
}
